import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import nurse from "../img/nurse.png";
import iot from "../img/iot.png";
import Container, { Direction } from "../components/Container";
import { useEffect, useState } from "react";

const Page = () => {
  const { t } = useTranslation();
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize)
    };
  }, [setWidth]);

  const btnData = [
    {
      link: "/iot-platform",
      text: t("text1"),
      src: iot
    },
    {
      link: "/nurse-call-system",
      text: t("text2"),
      src: nurse
    },
  ];

  const handleClick = (e: any) => {
    const userConfirmed = window.confirm("Открыть сайт?");

    if (!userConfirmed) {
      e.preventDefault();
    }
  };

  return (
    <div className={styles.page}>
      <p className={styles.title}>{t("title")}</p>
      <Container
        className={styles.content}
        direction={width > 600 ? Direction.Row : Direction.Column}
        gap={width > 600 ? 20 : 10}
      >
        {btnData.map((e, i) => (
          <a onClick={handleClick} href={e.link} key={i} target="_blank" rel="noopener noreferrer">
            <div className={styles.btn}>
              <p className={styles.txt}>{e.text}</p>
              {width > 600 ? (
                <div className={styles.imgWr}>
                  <img src={e.src} className={styles.img} alt="img" />
                </div>
              ) : ""}
            </div>
          </a>
        ))}
      </Container>
    </div>
  )
}

export default Page;
